
import Flag from '../assets/images/Flag.png';
// import PurpleFushia from '../assets/images/icons/Purple_Fushia.svg';
// import Devider from '../assets/images/icons/Devider.svg';
// import LangIcon from '../assets/images/icons/lang.svg';
import Wrapper from '../assets/wrappers/topHeader';
import React from 'react';
import { useLocation } from 'react-router-dom';


const TopHeader : React.FC = () => {

    const location = useLocation();

  const handleSkip = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    let targetId = '';

    switch (location.pathname) {
      case '/':
        targetId = 'homeMainContent';
        break;
      case '/upload':
        targetId = 'uploadMainSkip';
        break;
      case '/processing':
        targetId = 'processingSkipMain';
        break;
      default:
        break;
    }

    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.setAttribute('tabindex', '-1'); // for accessibility
      targetElement.focus();
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };



  return (
    <Wrapper>
    <div className="top-header" id="topHeaderMain">
      <div className="top-header-left">
        <img src={Flag} alt="" />
        <span>
          Government of India <i className="fa fa-external-link" aria-hidden="true"></i>
        </span>
      </div>

      <div className="top-header-right">
          <a href="skip" onClick={handleSkip} className="skip-link" data-nosnippet >
        Skip to Main Content
      </a>
        {/* <div className="top-icons">
          <img src={PurpleFushia} alt="Purple_Fushia" />
          <img src={Devider} alt="icon-devider" />
          <img src={LangIcon} alt="language-icon" />
        </div> */}
      </div>
    </div>
    </Wrapper>
  );
};

export default TopHeader;
